import { render, staticRenderFns } from "./add-news-category.vue?vue&type=template&id=8f3f710a&scoped=true"
import script from "./add-news-category.vue?vue&type=script&lang=js"
export * from "./add-news-category.vue?vue&type=script&lang=js"
import style0 from "./add-news-category.vue?vue&type=style&index=0&id=8f3f710a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3f710a",
  null
  
)

export default component.exports